import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OCRPipe } from '../../pipes/ocr.pipe';
import { SharedModule } from '../shared.module';
import { BarControlViewerComponent } from './components/barcontrol-viewer/bar-control-viewer.component';
import { ControlModule } from './control.module';
import { BarControlComponent } from './pages/bar-control/bar-control.component';

const routes: Routes = [
  {
    path: '',
    component: BarControlComponent,
    data: { animation: 'isLeft' },
  },
];

@NgModule({
  declarations: [BarControlViewerComponent, BarControlComponent, OCRPipe],
  imports: [RouterModule.forChild(routes), SharedModule, ControlModule],
  providers: [],
})
export class BarControlModule {}
